module.exports = __webpack_public_path__ + "media/customizations/royaloaks/back-f154f3fd7237e49a4eb59521b2a9255a.jpg";